import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { PaymentService } from '@fcom/common-booking/services/payment.service';
import { RedirectServiceModule } from '@fcom/common-booking/modules/redirect-service/';
import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { ComponentsModule } from '@fcom/common/components';
import { CmsModule } from '@fcom/cms';
import { CmsPageService, ImagesModule, NavigationModule, PipesModule } from '@fcom/common';
import { DirectiveModule } from '@fcom/common/directives';
import { LoginModule } from '@fcom/common/login';
import { LocalizationProvider } from '@fcom/core/services/language/localization.provider';
import { LocationsModule } from '@fcom/locations';
import { MmbOrderModule } from '@fcom/manage-booking-common';
import { CommonBookingComponentsModule } from '@fcom/common-booking';
import { GtmModule } from '@fcom/common/gtm';
import { CommonBookingAncillaryService } from '@fcom/common-booking/modules/ancillaries/services';
import { I18nKey } from '@fcom/core';
import { UtilsService } from '@fcom/common-booking/services/utils.service';

import { ManageBookingRoutesModule } from './manage-booking.routes';
import { ManageBookingSideNavigationComponent } from './components';
import { MANAGE_BOOKING_FEATURE_KEY } from './constants';
import { reducers } from './store';
import { ManageBookingService, OffersService } from './services';
import { StageEffects } from './store/effects/stage.effects';
import { NotificationsService } from './services/notifications.service';
import { ManageBookingRoutingComponent } from './components/manage-booking-routing/manage-booking-routing.component';
import { PnrFormService } from './services/pnr-form-service';
import { CarTrawlerWidgetService } from './services/cartrawler-widget/cartrawler-widget.service';
import { CheckInService } from './services/check-in.service';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    CommonBookingComponentsModule,
    NavigationModule,
    ManageBookingRoutesModule,
    LocationsModule,
    FormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    UiComponentsModule,
    UiTranslateModule,
    StoreModule.forFeature(MANAGE_BOOKING_FEATURE_KEY, reducers),
    EffectsModule.forFeature([StageEffects]),
    CmsModule,
    GtmModule,
    ImagesModule,
    PipesModule,
    DirectiveModule,
    LoginModule,
    MmbOrderModule,
    RedirectServiceModule,
  ],
  providers: [
    CmsPageService,
    ManageBookingService,
    UtilsService,
    NotificationsService,
    CommonBookingAncillaryService,
    PaymentService,
    OffersService,
    PnrFormService,
    CarTrawlerWidgetService,
    CheckInService,
  ],
  declarations: [ManageBookingRoutingComponent, ManageBookingSideNavigationComponent],
  exports: [],
})
export class ManageBookingModule {
  constructor(private localizationProvider: LocalizationProvider) {
    this.localizationProvider.triggerLazyLocalizations(I18nKey.MMB);
  }
}
